<div>
  <form [formGroup]="toolchainForm">
    <div class="toolchain-config-component">
      <div class="toolchain-data-container">
        <mat-form-field>
          <mat-label>Tool chain ID</mat-label>
          <input matInput formControlName="toolchainId" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Toolchain name</mat-label>
          <input matInput formControlName="toolchainName" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Toolchain display name</mat-label>
          <input matInput formControlName="toolchainDisplayName" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Toolchain version</mat-label>
          <input matInput formControlName="version" readonly />
        </mat-form-field>
      </div>
      <div class="toolchain-details">
        <mat-form-field class="toolchain-description-field">
          <mat-label>Tool chain description</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            formControlName="toolchainDescription"
            readonly></textarea>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Project</mat-label>
          <input matInput formControlName="project" readonly />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Author</mat-label>
          <input matInput formControlName="author" readonly />
        </mat-form-field>
        <div class="toolchain-controls">
          <button mat-stroked-button color="primary" (click)="openRegistrations()">
            Manage access
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
